<template>
	<div class="performance">
		<monitorHead title="网站性能" :img="img" :text="text" v-if="showTop"></monitorHead>
		<div class="score">
			<div class="score_left">
				<div class="score_left_item">
					<div class="score_left_head">
						<i class="icon el-icon-success" v-if="details.dnsFlag" style="color: #43b58e"></i>
						<i class="icon el-icon-error" style="color: #f5222d" v-else></i>
						<span class="score_left_title">智能DNS解析</span>
					</div>
					<div class="score_left_text">
						流量比较大的网站，可以通过智能DNS把流量分配到几台不同的服务器上来提高网站的运行速度。
					</div>
				</div>
				<div class="score_left_item">
					<div class="score_left_head">
						<i class="icon el-icon-success" v-if="details.webpFlag" style="color: #43b58e"></i>
						<i class="icon el-icon-error" style="color: #f5222d" v-else></i>
						<span class="score_left_title">图片Webp压缩</span>
					</div>
					<div class="score_left_text">
						不影响图片格式兼容与实际清晰度情况下可以让整体网页下载速度加快。
					</div>
				</div>
				<div class="score_left_item">
					<div class="score_left_head">
						<i class="icon el-icon-success" v-if="details.cacheFlag" style="color: #43b58e"></i>
						<i class="icon el-icon-error" style="color: #f5222d" v-else></i>
						<span class="score_left_title">缓存技术</span>
					</div>
					<div class="score_left_text">使用缓存技术充当数据的本地存储，可加快查找或检索速度。</div>
				</div>
			</div>
			<div class="score_right">
				<div class="score_right_item">
					<div class="score_right_title">页面大小</div>
					<div class="score_right_text">
						页面大小与网站页面内容有关，页面大小3M以内整体的加载体验会更好
					</div>
					<scoreProgressBar
						:progressBarConfig="sizeProgressBarConfig"
						:num="details.pageBytes"
					></scoreProgressBar>
				</div>
				<div class="score_right_item">
					<div class="score_right_title">资源请求</div>
					<div class="score_right_text">
						页面资源数量与页面内容及脚本数量和第三方插件代码有关系，页面资源请求数越多，加载会越慢
					</div>
					<scoreProgressBar
						:progressBarConfig="requestProgressBarConfig"
						:num="details.pageElements"
					></scoreProgressBar>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import monitorHead from './monitorHead';
import img from '@/assets/websiteMonitor/websitePerformance.png';
import scoreProgressBar from './scoreProgressBar';

export default {
	name: 'performance',
	props: {
		details: Object,
		showTop: {
			type: Boolean,
			default: true,
		},
	},
	components: {
		monitorHead,
		scoreProgressBar,
	},
	data() {
		return {
			img,
			text: '良好的海外服务器和CDN加速服务，不仅可以加快网站的访问速度，让不同地区不同网络环境的用户可以在最短的时间内获得最快的页面加载速度，比单节点服务器可提升了40%的访问速度。',
			sizeProgressBarConfig: {
				tips: [
					{
						label: '0-4.9M',
						color: '#43B58E',
					},
					{
						label: '5-9.9M',
						color: '#FCE06C',
					},
					{
						label: '超过10M',
						color: '#ED4F28',
					},
				],
				setConfig: num => {
					let numCopy = (num / 1048576).toFixed(1);
					if (numCopy > 0 && numCopy <= 4.9) {
						return {
							activeColor: '#43B58E',
							text: `${numCopy}M`,
							percent: (1 - numCopy / 10) * 100,
						};
					} else if (numCopy >= 5 && numCopy <= 9.9) {
						return {
							activeColor: '#FCE06C',
							text: `${numCopy}M`,
							percent: (1 - numCopy / 10) * 100,
						};
					} else if (numCopy >= 10) {
						return {
							activeColor: '#ED4F28',
							text: `${numCopy}M`,
							percent: (1 - numCopy / 10) * 100,
						};
					}
				},
			},
			requestProgressBarConfig: {
				tips: [
					{
						label: '50以内',
						color: '#43B58E',
					},
					{
						label: '99以内',
						color: '#FCE06C',
					},
					{
						label: '100以上',
						color: '#ED4F28',
					},
				],
				setConfig: num => {
					if (num > 0 && num < 50) {
						return {
							activeColor: '#43B58E',
							text: num,
							percent: 100 - num,
						};
					} else if (num >= 50 && num < 99) {
						return {
							activeColor: '#FCE06C',
							text: num,
							percent: 100 - num,
						};
					} else if (num >= 99) {
						return {
							activeColor: '#ED4F28',
							text: num,
							percent: 100 - num < 0 ? 0 : 100 - num,
						};
					}
				},
			},
		};
	},
};
</script>

<style lang="scss" scoped>
.performance {
	background: #ffffff;
	box-shadow: 0px 4px 4px 0px rgba(67, 93, 255, 0.05);
	margin-bottom: 10px;
	padding: 0 100px 50px;

	.score {
		margin-top: 20px;
		display: flex;

		.score_left,
		.score_right {
			flex: 1;
			width: 0;
		}

		.score_left {
			display: flex;
			flex-direction: column;
			justify-content: center;

			.score_left_item {
				margin-bottom: 20px;
				.score_left_head {
					display: flex;
					align-items: center;

					.icon {
						font-size: 25px;
					}
					.score_left_title {
						margin-left: 10px;
						font-size: 16px;
						font-weight: 600;
						color: #333333;
					}
				}

				.score_left_text {
					margin-left: 35px;
					margin-top: 10px;
					font-size: 15px;
				}
			}
		}

		.score_right {
			display: flex;

			.score_right_item {
				display: flex;
				flex: 1;
				width: 0;
				padding: 0 20px;
				flex-direction: column;
				align-items: center;

				.score_right_title {
					font-size: 16px;
					font-weight: 600;
				}

				.score_right_text {
					font-size: 14px;
					margin: 15px 0 30px;
					display: -webkit-box; //将对象作为弹性伸缩盒子模型显示。
					-webkit-box-orient: vertical; //从上到下垂直排列子元素（设置伸缩盒子的子元素排列方式）
					-webkit-line-clamp: 2; //限制行数
					overflow: hidden; //超出部分隐藏
					text-overflow: ellipsis; //用一个省略号代替超出的内容
				}
			}
		}
	}
}
</style>
